'use strict';

var _ = require('lodash');

exports.showFbMin = function (space) {
  return !_.get(space, 'data.hidden.fbMin');
};